import { render, staticRenderFns } from "./TiempoHistorico.vue?vue&type=template&id=3056f97a&"
import script from "./TiempoHistorico.vue?vue&type=script&lang=js&"
export * from "./TiempoHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports